import React from 'react';
import { PhoneBlockProps } from '@app/ui/pages/landing-page/header/phone-block/phone-block.types';
import { Box, Typography } from '@mui/material';
import {
  PhoneBlockWrapper,
  PhoneLink,
} from '@app/ui/pages/landing-page/header/phone-block/phone-block.styles';
import { shouldShowMainPhone } from '@app/utils/domainHelpers';
import { TELEGRAM_BOT, TELEGRAM_BOT_NAME } from '@app/config';
// @ts-ignore
import telegramIcon from '@app/assets/telegram.png';

/**
 * Блок с телефонами в шапке сайта.
 *
 * - Основной телефон показывается только на ok-telecom.ru.
 * - На остальных доменах под вторым номером отображается компактная строка
 *   со ссылкой на Telegram-бота (маленькая иконка + имя бота).
 */
export const PhoneBlock: React.FC<PhoneBlockProps> = (props) => {
  const { phone, phoneSecond, href } = props;
  const showMainPhone = shouldShowMainPhone();

  return (
    <PhoneBlockWrapper>
      {showMainPhone && (
        <PhoneLink href={href || `tel:${phone}`}>
          <Typography fontSize={'18px'} variant='h6'>{phone}</Typography>
        </PhoneLink>
      )}
      <PhoneLink href={href || `tel:${phoneSecond}`}>
        <Typography fontSize={'18px'} variant='h6'>{phoneSecond}</Typography>
      </PhoneLink>

      {/* На доменах без основного телефона под номером показываем
          компактную строку со ссылкой на Telegram-бота */}
      {!showMainPhone && TELEGRAM_BOT_NAME && (
        <PhoneLink
          href={TELEGRAM_BOT}
          target='_blank'
          rel='noopener noreferrer'
        >
          <Box display='flex' flexDirection='row' alignItems='center' marginTop='4px'>
            <img src={telegramIcon} width='20px' height='20px' alt='Telegram' />
            <Typography fontSize={'14px'} variant='body2' marginLeft='6px' color='text.secondary'>
              {TELEGRAM_BOT_NAME.toLowerCase()}
            </Typography>
          </Box>
        </PhoneLink>
      )}
    </PhoneBlockWrapper>
  );
};
